// extracted by mini-css-extract-plugin
module.exports = {"link":"footer_link__UJxmZ","link_desktop":"footer_link_desktop__XZUcl","desktop_footer":"footer_desktop_footer__N8kVJ"};